"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));
var _ref = /*#__PURE__*/
_react.default.createElement("path", {
  d: "M0 1807.118V113h1920v1694.118H0zm112.941-112.829H1807.06V225.941H112.94V1694.29zm1580.499-291.388l10.504 65.393H207.924l20.104-71.718c85.384-306.07 172.913-457.072 283.37-489.712 102.55-30.156 185.336 43.82 258.86 109.1 43.596 38.514 90.806 81.092 122.542 78.834 15.925-1.807 32.188-20.556 43.144-36.029 182.851-258.409 332.498-286.87 426.691-264.847 160.716 37.384 272.076 242.26 330.805 608.98zm-1335.755-47.548h1212.762c-50.485-265.186-134.4-428.386-233.336-451.426-83.012-19.313-196.066 60.762-308.895 220.01-35.237 49.807-76.348 77.816-122.315 83.124-81.092 9.6-146.033-49.694-210.41-106.503-54.211-48.113-110.682-97.017-152.018-85.384-34.447 10.165-102.325 69.12-185.788 340.179zm319.962-564.706c-124.574 0-225.882-101.308-225.882-225.882s101.308-225.883 225.882-225.883S903.53 440.191 903.53 564.765c0 124.574-101.308 225.882-225.882 225.882zm0-338.823c-62.343 0-112.941 50.71-112.941 112.94 0 62.231 50.598 112.942 112.941 112.942 62.344 0 112.941-50.71 112.941-112.941 0-62.23-50.597-112.941-112.94-112.941z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});
var IconImage = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconImage, _Component);
  function IconImage() {
    (0, _classCallCheck2.default)(this, IconImage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconImage).apply(this, arguments));
  }
  (0, _createClass2.default)(IconImage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconImage",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconImage.displayName = "IconImage";
  return IconImage;
}(_react.Component);
exports.default = IconImage;
IconImage.glyphName = 'image';
IconImage.variant = 'Line';
IconImage.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);